import { DollarSign, TrendingUp, Users, UserCheck } from 'lucide-react';
import type { FinancialKpis } from '@crm/shared';

interface KpiCardsProps {
  kpis: FinancialKpis;
}

function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

const cards = [
  { key: 'mrr' as const, label: 'MRR', icon: DollarSign, color: 'text-green-600 bg-green-100' },
  { key: 'arr' as const, label: 'ARR', icon: TrendingUp, color: 'text-blue-600 bg-blue-100' },
  {
    key: 'totalActiveSubscriptions' as const,
    label: 'Assinantes Ativos',
    icon: Users,
    color: 'text-purple-600 bg-purple-100',
  },
  { key: 'arpu' as const, label: 'ARPU', icon: UserCheck, color: 'text-orange-600 bg-orange-100' },
];

export function KpiCards({ kpis }: KpiCardsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => {
        const value = kpis[card.key];
        const display = card.key === 'totalActiveSubscriptions' ? value : formatCurrency(value);

        return (
          <div key={card.key} className="bg-white rounded-xl border border-secondary-200 p-5">
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm font-medium text-secondary-500">{card.label}</span>
              <div className={`p-2 rounded-lg ${card.color}`}>
                <card.icon className="w-4 h-4" />
              </div>
            </div>
            <p className="text-2xl font-bold text-secondary-900">{display}</p>
          </div>
        );
      })}
    </div>
  );
}
